// TOP LEVEL IMPORTS
import React from 'react';
import ReactCloudinaryUploader from '@app-masters/react-cloudinary-uploader';
// ANTD
import Button from 'components/common/Button';
import Icon from 'components/common/Icon';
import Form from 'antd/lib/form';
//
import { Image, CloudinaryContext, Transformation } from 'cloudinary-react';

const FormItem = Form.Item;

class ImageUploadInput extends React.PureComponent {
  state = {
    loading: false,
    public_id: null,
  };

  componentWillReceiveProps(newProps) {
    // if the parent is passing in an empty this.props.providers array, we should make sure out local state is empty too
    if (newProps.image) {
      return this.setState({
        image: newProps.image,
      });
    }
  }

  onSuccess = ({ secure_url, public_id }) => {
    console.log(secure_url);
    this.setState({ loading: false, image: secure_url, public_id });
    this.props.onChange(secure_url);
  };

  onError = err => {
    this.setState({ loading: false });
    console.error(err);
  };

  onClick = () => {
    let options = {
      cloud_name: 'foundry41',
      upload_preset: 'heyend-staging',
      cropping: 'server',
      allowedFormats: ['jpeg', 'png'],
      show_powered_by: false,
      multiple: false,
      ...this.props.cloudinaryOptions,
      // multiple: true,
      // returnJustUrl: true
    };
    this.setState({ loading: true });
    ReactCloudinaryUploader.open(options)
      .then(this.onSuccess)
      .catch(this.onError);
  };

  onDelete = () => {
    this.setState({ loading: false, image: null, public_id: null });
    this.props.onChange(null);
  };

  render() {
    return (
      <React.Fragment>
        {!this.props.value && (
          <Button
            onClick={this.onClick}
            loading={this.state.loading}
            disabled={this.state.loading}
            type="dashed"
            icon="cloud-upload-o"
          >
            {!this.state.loading ? this.props.buttonText : 'UPLOADING...'}
          </Button>
        )}
        {this.props.value && (
          <React.Fragment>
            <Icon
              type="close-circle-o"
              style={{ fontSize: 18, color: 'red', cursor: 'pointer' }}
              onClick={this.onDelete}
            />
            <img src={this.props.value} width={this.props.imageWidth} height={this.props.imageHeight} crop="scale" />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

ImageUploadInput.defaultProps = {
  buttonText: 'Upload Image',
  cloudinaryOptions: {},
  imageHeight: 150,
  imageWidth: 150,
};

export default ImageUploadInput;



// WEBPACK FOOTER //
// ./src/components/inputs/ImageUploadInput/index.js